// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@babel/polyfill'
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from '@/router'
import { store } from '@/app/store'
import moment from 'moment'
import BootstrapVue from 'bootstrap-vue'
import '@/assets/scss/app.scss'
import App from '@/app/App'
import vueTopprogress from 'vue-top-progress'
import AuthenticationService from '@/app/authentication/authentication.service'
import { formatDate, point } from '@/app/filters'
import VueAuthImage from 'vue-auth-image'
import Pagination from 'vue-pagination-2'
import MugenScroll from 'vue-mugen-scroll'
import Toaster from 'v-toaster'
import 'v-toaster/dist/v-toaster.css'
import VueUploadComponent from 'vue-upload-component'
import Vue2Filters from 'vue2-filters'
import { saveAs } from 'file-saver';
import Multiselect from 'vue-multiselect'
import Toasted from 'vue-toasted';
import VueGtag from "vue-gtag";
import VModal from 'vue-js-modal'

import 'promise-polyfill/src/polyfill';
Vue.prototype.moment = moment;

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function (searchString, position) {
    position = position || 0;
    return this.indexOf(searchString, position) === position;
  };
}

String.prototype.toDate = function (format) {
  var normalized = this.replace(/[^a-zA-Z0-9]/g, '-');
  var normalizedFormat = format.toLowerCase().replace(/[^a-zA-Z0-9]/g, '-');
  var formatItems = normalizedFormat.split('-');
  var dateItems = normalized.split('-');

  var monthIndex = formatItems.indexOf("mm");
  var dayIndex = formatItems.indexOf("dd");
  var yearIndex = formatItems.indexOf("yyyy");
  var hourIndex = formatItems.indexOf("hh");
  var minutesIndex = formatItems.indexOf("ii");
  var secondsIndex = formatItems.indexOf("ss");

  var today = new Date();

  var year = yearIndex > -1 ? dateItems[yearIndex] : today.getFullYear();
  var month = monthIndex > -1 ? dateItems[monthIndex] - 1 : today.getMonth() - 1;
  var day = dayIndex > -1 ? dateItems[dayIndex] : today.getDate();

  var hour = hourIndex > -1 ? dateItems[hourIndex] : today.getHours();
  var minute = minutesIndex > -1 ? dateItems[minutesIndex] : today.getMinutes();
  var second = secondsIndex > -1 ? dateItems[secondsIndex] : today.getSeconds();

  return new Date(year, month, day, hour, minute, second);
};

Vue.config.productionTip = false
axios.defaults.baseURL = process.env.API_URL
if (window.$cookies.get(process.env.AUTH_COOKIE_NAME)) axios.defaults.headers.Authorization = window.$cookies.get(process.env.AUTH_COOKIE_NAME)
moment.locale('pl-PL')
window.$ = window.jQuery = require('jquery');

// Axios interceptor
axios.interceptors.response.use(null, function (error) {
  // Logout when API return unathorized
  if (error.response.status === 401) {
    AuthenticationService.logout(false)
  }

  return Promise.reject(error)
});

Vue.use(VueCookies)
Vue.use(VueAxios, axios)
Vue.use(BootstrapVue)
Vue.use(vueTopprogress)
Vue.use(VueAuthImage)
Vue.use(Toaster, { timeout: 5000 })
Vue.use(Vue2Filters)
Vue.use(Toasted)
Vue.use(VModal)
Vue.use(VueGtag, {
  config: {
    id: "GTM-PMZQ9BR2",
    params: {
      send_page_view: true
    }
  }
});

Vue.component('pagination', Pagination)
Vue.component('mugenScroll', MugenScroll)
Vue.component('VueUploadComponent', VueUploadComponent)
Vue.component('multiselect', Multiselect)

// Set meta
router.beforeEach((to, from, next) => {
  document.title = (to['meta'].title ? to['meta'].title + ' - ' : '') + 'Geberit'
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store
})



// WEBPACK FOOTER //
// ./src/main.js